import React, {Component} from 'react';
import { connect } from 'react-redux';
import MoviesResults from "../../movieresults/movieresults.component";

class SerialsContainer extends Component {

    getCards() {
        const cards = [
            {
                imgSrc: 'https://i.imgur.com/KDlgGUQ.jpg',
                title: 'Ant-Man and the Wasp',
                year: '2018',
                translatedTitle: 'Omul Furnica',
                preview: true,
                genre: 'Comedie, Animatie, SF',
                grade: '8,7',
                writers: 'Chris McKenna, Erik Sommers',
                director: 'Peyton Reed',
                stars: 'Paul Rudd, Evangeline Lilly, Michael Pena',
                details: 'PG | 1h58 min | Comedie, Animatie, SF | 2D, 3D',
                launchDate: '8 Iulie 2018'
            },
            {
                imgSrc: 'https://i.imgur.com/WSxYIcb.jpg',
                title: 'Moonlight',
                year: '2018',
                translatedTitle: 'Omul Furnica',
                preview: true,
                genre: 'Comedie, Animatie, SF',
                grade: '8,7',
                writers: 'Chris McKenna, Erik Sommers',
                director: 'Peyton Reed',
                stars: 'Paul Rudd, Evangeline Lilly, Michael Pena',
                details: 'PG | 1h58 min | Comedie, Animatie, SF | 2D, 3D',
                launchDate: '8 Iulie 2018'
            },
            {
                imgSrc: 'https://i.imgur.com/7UlYjeS.jpg',
                title: 'Manchester Sea',
                year: '2018',
                translatedTitle: 'Omul Furnica',
                preview: true,
                genre: 'Comedie, Animatie, SF',
                grade: '8,7',
                writers: 'Chris McKenna, Erik Sommers',
                director: 'Peyton Reed',
                stars: 'Paul Rudd, Evangeline Lilly, Michael Pena',
                details: 'PG | 1h58 min | Comedie, Animatie, SF | 2D, 3D',
                launchDate: '8 Iulie 2018'
            },
            {
                imgSrc: 'https://i.imgur.com/l57lZrq.jpg',
                title: 'Birdman',
                year: '2018',
                translatedTitle: 'Omul Furnica',
                preview: true,
                genre: 'Comedie, Animatie, SF',
                grade: '8,7',
                writers: 'Chris McKenna, Erik Sommers',
                director: 'Peyton Reed',
                stars: 'Paul Rudd, Evangeline Lilly, Michael Pena',
                details: 'PG | 1h58 min | Comedie, Animatie, SF | 2D, 3D',
                launchDate: '8 Iulie 2018'
            },
            {
                imgSrc: 'https://i.imgur.com/skP1H3s.jpg',
                title: '12 Years a Slave',
                year: '2018',
                translatedTitle: 'Omul Furnica',
                preview: true,
                genre: 'Comedie, Animatie, SF',
                grade: '8,7',
                writers: 'Chris McKenna, Erik Sommers',
                director: 'Peyton Reed',
                stars: 'Paul Rudd, Evangeline Lilly, Michael Pena',
                details: 'PG | 1h58 min | Comedie, Animatie, SF | 2D, 3D',
                launchDate: '8 Iulie 2018'
            },
            {
                imgSrc: 'https://i.imgur.com/KDlgGUQ.jpg',
                title: 'Ant-Man and the Wasp',
                year: '2018',
                translatedTitle: 'Omul Furnica',
                preview: true,
                genre: 'Comedie, Animatie, SF',
                grade: '8,7',
                writers: 'Chris McKenna, Erik Sommers',
                director: 'Peyton Reed',
                stars: 'Paul Rudd, Evangeline Lilly, Michael Pena',
                details: 'PG | 1h58 min | Comedie, Animatie, SF | 2D, 3D',
                launchDate: '8 Iulie 2018'
            },
            {
                imgSrc: 'https://i.imgur.com/KDlgGUQ.jpg',
                title: 'Ant-Man and the Wasp',
                year: '2018',
                translatedTitle: 'Omul Furnica',
                preview: true,
                genre: 'Comedie, Animatie, SF',
                grade: '8,7',
                writers: 'Chris McKenna, Erik Sommers',
                director: 'Peyton Reed',
                stars: 'Paul Rudd, Evangeline Lilly, Michael Pena',
                details: 'PG | 1h58 min | Comedie, Animatie, SF | 2D, 3D',
                launchDate: '8 Iulie 2018'
            },
            {
                imgSrc: 'https://i.imgur.com/KDlgGUQ.jpg',
                title: 'Ant-Man and the Wasp',
                year: '2018',
                translatedTitle: 'Omul Furnica',
                preview: true,
                genre: 'Comedie, Animatie, SF',
                grade: '8,7',
                writers: 'Chris McKenna, Erik Sommers',
                director: 'Peyton Reed',
                stars: 'Paul Rudd, Evangeline Lilly, Michael Pena',
                details: 'PG | 1h58 min | Comedie, Animatie, SF | 2D, 3D',
                launchDate: '8 Iulie 2018'
            },
            {
                imgSrc: 'https://i.imgur.com/KDlgGUQ.jpg',
                title: 'Ant-Man and the Wasp',
                year: '2018',
                translatedTitle: 'Omul Furnica',
                preview: true,
                genre: 'Comedie, Animatie, SF',
                grade: '8,7',
                writers: 'Chris McKenna, Erik Sommers',
                director: 'Peyton Reed',
                stars: 'Paul Rudd, Evangeline Lilly, Michael Pena',
                details: 'PG | 1h58 min | Comedie, Animatie, SF | 2D, 3D',
                launchDate: '8 Iulie 2018'
            },
        ];

        return cards;
    }

    render() {
        return (
            <div className="serials-container">
                <MoviesResults cards={this.getCards()}/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(SerialsContainer);





// WEBPACK FOOTER //
// ./src/FO/components/serials/containers/serialscontainer.component.js